<svelte:head>
  <title>Admin portal | A Good Thing</title>
</svelte:head>

{#if $appState.user}
  <div class="tile is-ancestor">
    <div class="tile is-vertical">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <p class="title">Hi, {$appState.user?.firstName}</p>
          {#if $appState.user.isDelegatedAdmin}
          <p>This is the admin portal. You're logged on as a delegated administrator.</p>
          <p>You can view and manage all businesses tagged with '{$appState.user.delegatedAdminTag}' and their offers.</p>
          {/if}
          {#if $appState.user.isFullCharityAdmin}
          <p>This is the admin portal. You're logged on as a charity administrator.</p>
          {/if}
          {#if $appState.user.isFullAdmin}
          <p>This is the admin portal. You're logged on as a full administrator.</p>
          {/if}
        </div>
      </div>
    </div>
  </div>

  {#if $appState.user.isFullAdmin}
  <section class="is-fullwidth is-flex-desktop" style="gap: 10px">
    <OffersTile />

    <CharityTile />
  </section>
  {/if}
{/if}

<script lang="ts">
  import _ from 'lodash';
  import { appState } from '../../lib/appState';
  import CharityTile from './home/CharityTile.svelte';
  import OffersTile from './home/OffersTile.svelte';
  import Offers from './business/[id]/offers.svelte';
</script>
